<template>
  <div class="">
    <template v-for="meta in metas">
      <OrderMetaSpotPlayer1 :meta="meta" v-if="meta.name =='order_spot_player' "/>
    </template>
  </div>
</template>


<script>
import OrderMetaSpotPlayer1 from "./components/OrderMetaSpotPlayer1.vue";

export default {
  name: "MetaManager1.vue",
  components: {OrderMetaSpotPlayer1},
  props: {
    metas: {}
  }
}
</script>

<style scoped>

</style>